import React, { Component } from 'react';
import LoanApply from '../../../presentationals/Admin/ApplicationLeads/CreditVidyaLeads.component';
import { APIS } from '../../../../utils/api-factory'
import UserDetail from '../CustomerPages/UserDetailMain.container';
import { getCreditVidyaLead,getUserDetailByLoanId, getUserDetailApiAdmin, getistByNumber, getlistByEmail } from '../AdminActionCreator.component';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Popup from '../../../presentationals/Popup/Popup.component'

let paginationNumber = 10;

class LoanApplyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            forwordPageState: 1,
            loadarState: false,
            popupState: false,
            popupStatus: '',
            creditVidyaData: '',
            tableMinPagination: 0,
            tableMaxPagination: paginationNumber,
            pageViewState: 'leads',
            allDetail: '',
            userDetail: '',
            actionButtonState: false,
            markCompleteBtn: false,
            searchByemail: '',
            searchBymobile: '',
        }
    }

    componentWillMount() {
        this.setState({
            creditVidyaData:this.props.creditVidyaData
        })
    }
    // getLoanLead() {
    //     let adminEmail = localStorageUtil.getFromLocalStorage("AdminemailId")
    //     this.setState({
    //         loadarState: true
    //     })
    //     this.props.getCreditVidyaLead( this.state.forwordPageState + '&nbfcName=creditvidya', this.state.searchByDate, nbfcName, this.state.searchByEndDate, this.state.tabType,
    //         (callBack) => {
    //             fetch(APIS.TODAYS_LOAN_COUNT + this.state.searchByDate)
    //                 .then(res => res.json())
    //                 .then(json => {
    //                     this.setState({ todaysApplicationNo: json })
    //                 })
    //             this.setState({
    //                 loadarState: false,
    //             })
    //         });
    // }

    getLoanLead() {
        
        this.setState({ loadarState: true })
        fetch(APIS.CREDIT_VIDYA_LEADS + this.state.forwordPageState + '&nbfcName=creditvidya')
            .then(res => res.json())
            .then(res => {
                this.setState({
                    creditVidyaData: res,
                    loadarState: false
                })
            })
    }

    componentDidMount() {
        
        this.getLoanLead()
    }

    render() {
        const { admin } = this.props
        return (
            <div className="full-height">
                {this.state.pageViewState == 'leads' ?
                    <LoanApply
                        dataFilter={this.dataFilter.bind(this)}
                        creditVidyaData={this.state.creditVidyaData}
                        loadarState={this.state.loadarState}
                        paginationHandler={this.paginationHandler.bind(this)}
                        userDetailHandler={this.userDetailHandler.bind(this)}
                        phocketTablePagination={this.phocketTablePagination.bind(this)}
                        tableMinPagination={this.state.tableMinPagination}
                        tableMaxPagination={this.state.tableMaxPagination}
                        refreshLeads={this.refreshLeads.bind(this)}
                    />
                    : this.state.pageViewState == 'details' ?
                        <UserDetail
                            allDetail={this.state.allDetail}
                            userDetail={this.state.userDetail}
                            admin={admin}
                            backHandler={this.backHandler.bind(this)}
                            actionButtonState={this.state.actionButtonState}
                            markCompleteBtn={this.state.markCompleteBtn}
                        />
                        : null}

                {this.state.popupState == true ?
                    <Popup
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                    : ""}
            </div>
        )
    }
    dataFilter(e, type) {
        const { admin } = this.props
        if (type == "email") {
            this.setState({ searchByemail: e.target.value })
            // let email = e.target.value
            if (e.target.value.length > 2) {
                this.setState({
                    loadarState: true
                })
                this.props.getlistByEmail(e.target.value, 1, '', admin,
                    (callBack) => {
                        this.setState({
                            loadarState: false
                        })
                    })
            }
        } else if (type == "mobileNo") {
            this.setState({ searchBymobile: e.target.value })
            // let mobile = e.target.value
            if (e.target.value.length > 9) {
                this.setState({
                    loadarState: true
                })
                this.props.getistByNumber(e.target.value, 1, '', admin,
                    (callBack) => {
                        this.setState({
                            loadarState: false
                        })
                    })
            }
        }
    }

    refreshLeads() {
        this.getLoanLead()
    }

    userDetailHandler(data) {
        if (data.loanId != null && data.loanId != '') {
            getUserDetailByLoanId(data.loanId,
                (callBack) => {
                    this.setState({
                        pageViewState: 'details',
                        allDetail: callBack,
                        userDetail: data,
                    })
                })
        } else {
            getUserDetailApiAdmin(data.userId,
                (callBack) => {
                    this.setState({
                        pageViewState: 'details',
                        allDetail: callBack,
                        userDetail: data,
                    })
                })
        }
    }

    backHandler() {
        this.setState({
            pageViewState: 'leads'
        })
    }

    paginationHandler(type) {
        if (type == 'left') {
            if (this.state.forwordPageState > 1) {
                this.setState({
                    forwordPageState: this.state.forwordPageState - 1,
                    tableMinPagination: 0,
                    tableMaxPagination: paginationNumber,
                }, () => this.getLoanLead())
            }
        } else if (type == 'right') {
            this.setState({
                forwordPageState: this.state.forwordPageState + 1,
                tableMinPagination: 0,
                tableMaxPagination: paginationNumber,
            }, () => this.getLoanLead())
        }
    }

    phocketTablePagination(data, type) {
        if (type == 'back') {
            if (this.state.tableMinPagination >= paginationNumber) {
                this.setState({
                    tableMinPagination: this.state.tableMinPagination - paginationNumber,
                    tableMaxPagination: this.state.tableMaxPagination - paginationNumber,
                })
            }
        } else if (type == 'forward') {
            if (this.state.tableMaxPagination < data.length) {
                this.setState({
                    tableMaxPagination: this.state.tableMaxPagination + paginationNumber,
                    tableMinPagination: this.state.tableMinPagination + paginationNumber
                })
            }
        }
    }

    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }

    closePopup() {
        this.setState({ popupState: false });
    }

}
const mapStateToProps = ({creditVidyaData }) => {
    return {
        creditVidyaData:creditVidyaData
    };
};
const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getistByNumber,
        getlistByEmail,
        // getUserDetailByLoanId,
        // getUserDetailApiAdmin
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LoanApplyContainer);